const MESSAGES = {
  // WEBSITES
  ENTER_WEBSITE_TITLE: 'Enter website title',
  ENTER_WEBSITE_ADDRESS: 'Enter website address',
  INVALID_WEBSITE_ADDRESS: 'Address is not valid',

  // Black list
  ALL_BLOCKED_REMOVED: 'All blocked users removed from blacklist',

  // convs archive
  CONVS_ARCHIVE_OPEN_CONV_SUCCESS:
    'Conversation has been transfered to you successfully. you can continue it from webapp',
  CONVS_ARCHIVE_ALREADY_ASSIGNED: 'The conversation is already assigned to you',
  CONVS_ARCHIVE_INFO_SAVED: 'User information was saved successfully',
  CONVS_ARCHIVE_EMAIL_WHEN_READY:
    'As soon as the output file is ready, we will email it to you',
  CONVS_ARCHIVE_EXPORT_LIMIT:
    'You can only receive the output file twice a day!',

  // Departments
  PROBLEM_CREATING_TEAM:
    'An error occurred while adding the team. Please try again.',
  TEAM_CREATE_SUCCESS: 'Team added successfuly',
  PROBLEM_EDITING_TEAM:
    'An error occurred while editing the team. Please try again.',
  PROBLEM_REMOVING_TEAM:
    'An error occurred while deleting the team. Please try again.',
  PROBLEM_REORDER: 'There was a problem during the reorder',
  SUCCESSFUL_REMOVING_TEAM: 'The removal of the team was done successfully',

  // faq
  FAQ_SUCCESSFUL_ADDED: 'FAQ successfully added',
  QUESTION_SUCCESSFUL_ADDED: 'Question successfully added',
  SORT_REORDER_SUCCESSFUL: 'The transfer was done successfully',
  FAQ_REMOVED: 'The FAQ deleted successfully!',

  // operators
  NEW_OPERATOR_SUCCESS_INVITE: 'The new operator was successfully invited.',
  OPERATOR_CHANGES_SUCCESSFUL: 'The operator changes were successfully saved.',
  MOBILE_REGISTERED_BEFORE: 'This mobile number is already registered.',

  // payments
  ENTERED_CODE_IS_WRONG: 'Entered code is wrong!',
  DISCOUNT_JUST_FOR_FIRST_FACTOR:
    ' This discount can only be applied to the first invoice!',
  CANT_DOWNGRADE_PACKAGE: 'It is not possible to upgrade to a lower package.',
  PROBLEM_WHILE_MAKING_INVOICE:
    'There was an error in creating the invoice. Please try again.',
  ENTERED_CODE_WRONG_TRY_AGAIN: 'Entered code is wrong, try again',

  // mutual
  UPLOAD_IMAGE_NOT_SUCCESSFUL: 'There was a problem uploading the image',
  FILL_EMPTY_FIELDS: 'Fill empty fields',
  SUCCESSFULL_EDITING: 'The editing was done successfully',
  CHANGES_SAVED: 'Changes saved',
  QUESTION_REMOVED: 'Question removed',
  SUCCESSFUL_UPDATING_INFO: 'The information has been updated successfully',
  PROBLEM_UPDATING_INFO_TRY_AGAIN:
    'An error occurred while updating the information. Please try again!',
  CORRECT_ERRORS: 'Please correct errors',
  PROBLEM_IN_PROCESS:
    'An error has occurred during the operation. Please try again.',
  CHAR_LENGTH_EXCEED: 'The number of characters exceeds the limit',
  FIELD_CANNOT_EMPTY: 'This field cannot be empty',
  REQUEST_SUBMITED_SUCCESS: 'Your request has been submitted successfully',
  INFO_SAVED_SUCCESS: 'Your information has been saved successfully',
  FILL_ALL_FIELDS: 'It is necessary to fill all fields',
  UPGRADE_TO_USE_FEATURE: 'To use this feature upgrade your package',
  EXPIRE_BANNER_ENDED_CREDIT: 'Your package has expired. Please renew it',
  REQUEST_ADD_APP_SUCCESS: 'Your application has been successfully added!',
  REQUEST_DELETE_APP_SUCCESS: 'The application has been successfully deleted!',

  // two-step verification
  SEND_CODE_REQUEST_EMAIL:
    'The verification code has been successfully sent to your email!',
  SEND_CODE_REQUEST_PHONE:
    'The verification code has been successfully sent to your phone number!',

  // settings
  SETTINGS_SUCCESSFUL_SAVED: 'Settings saved',
  AUTO_MSG_ADDED: 'Message added',
  AUTO_MSG_DELETED: 'Message deleted',
  AUTO_MSG_SENDER_CHANGES: 'Sender changed',
  AUTO_MSG_LEAST_CONDITION: 'It is neccessary to create at least one condition',
  AUTO_MSG_COMPLETE_CONDITION: 'Choose condition type',
  ADDRESS_INVALID: 'Address is invalid',
  AUTO_MSG_EDITOR_MAX_CHAR: 'Character limit reached!',
  WIDGET_AT_LEAST_ONE_ADDRESS: 'Add at least one address !',

  // user
  FOUR_DIGIT_CODE_SENT_BY_SMS: ' A 4-digit code was sent via SMS',
  PROBLEM_SENDING_CODE_BY_SMS:
    'The code has been sent to you. Please retry after 2 minutes to receive it again.',
  EMAIL_ALREADY_USED:
    'The email has already been registered. Enter another email',
  PHONE_NUM_ALREADY_USED:
    'The mobile phone is already registered. Enter another mobile phone.',
  PROBLEM_WHILE_SIGNING_UP:
    'There is a problem with registration. Please try again.',
  PASSWORD_IS_NOT_CORRECT: 'Password is not correct',
  DONT_HAVE_ACCESS_TO_THIS_SECTION:
    "Dear user, you do not have access to enter this section. Please enter another email or log in from the 'Chat with Users' section.",
  DONT_HAVE_ACCESS_ADMIN_PANEL:
    'You do not have permission to access the admin dashboard.',
  RESET_PASS_EMAIL_SENT:
    'The recovery email was sent. Please log in with the password sent to your email',
  NO_ACCOUNT_WITH_THIS_EMAIL:
    'The user account is not registered with this email. Please enter another email',

  // webhook
  NEW_WEBHOOK_ADDED: 'The new webhook was created successfully',

  // WEBSITE
  SITE_REGISTERED_BEFORE:
    'This site has already been registered. Please enter another website address',
  BARCODE_SCANNED_BEFORE:
    'This barcode has already been scanned. Please try again',
  WEBSITE_ADDED_SUCCESS: 'The website was successfully added',
  WEBSITE_NUM_MAX_ERROR: 'You are not allowed to add more than 5 websites',
  SITE_ALREADY_REGISTERED_IN_ANOTHER_ACCOUNT:
    'This site is already registered in another account. Please try another site',
  WEBSITE_ENABLE: 'Website enabled',
  WEBSITE_DISABLED: 'Website disabled',
  PROBLEM_ASSIGNING_OPERATOR:
    'An error has occurred in assigning the operator. Please try again',
  SELECTED_OPERATORS_ASSIGNED: 'The selected operators were allocated',
  MESSAGE_SENT: 'The message was sent successfully',
  MAX_GROUP_MSG_LIMIT_REACHED:
    'You have sent the maximum number of group messages today',
  WEBSITE_NOT_CONNECTED_WHATSAPP: 'Website is not connected to WhatsApp',

  // validations
  ENTER_EMAIL: 'Enter email',
  EMAIL_INVALID: 'Email is invalid',
  ENTER_PASSWORD: 'Enter password',
  ENTER_TITLE: 'Enter title',
  ENTER_NAME: 'Enter full name',
  NAME_CHAR_ERROR: 'Name should be more than two characters',
  NAME_INVALID_ERROR:
    'The name should not include numbers and spaces at the end',
  ENTER_MOBILE: 'Enter mobile number',
  INVALID_MOBILE: 'Mobile number is not valid',
  PASSWORD_LENGTH_INVALID: 'Password must be more than 8 letters or numbers',
  PASSWORD_INVALID_CHARS:
    'The password must contain uppercase and lowercase letters and numbers',
  PASSWORD_REPETITION_NOT_VALID: 'Passwords do not match',
  TITL_AND_NAME_SHOULDNT_EQUAL: 'Title and fullname should not be the same',
  INVALID_FILE_FORMAT: 'File format is not valid',
  IMAGE_SIZE_EXCEED: 'Image size is more than 500 KB',

  // signup validation
  SIGNUP_ENTER_NAME: 'Enter name',
  SIGNUP_NAME_LENGTH: 'Name should be more than one character',
  SIGNUP_NAME_INVALID: 'Name should not include numbers',
  ENTER_LASTNAME: 'Enter last name',
  SIGNUP_LASTNAME_LENGTH: 'Last name should be more than one character',
  SIGNUP_LASTNAME_INVALID: 'Last name should not include numbers',

  // handleErrors
  SERVER_ERROR: 'There is a problem connecting with the server.',
  UPGRADE_PACKAGE: 'To continue accessing, upgrade your package',
  SERVER_ERROR_TRY_AGAIN:
    'An error has occurred on the server. Please try again.',
  INVALID_ACCESS_LEVEL: 'The access level is not allowed.',
  CONTENT_NOT_FOUND: 'Content for your request was not found.',
  SENT_REQUEST_NOT_CORRECT: 'The request sent is not correct.',
  TOO_MANY_REQUESTS:
    'The number of requests is limited! Please try again later',

  // Copy to clipboard
  COPY_CODE_CLIPBOARD_ERROR:
    'An error occurred while copying the script. Please try again',
  COPY_CODE_CLIPBOARD_SUCCESS: 'Copied!',

  // Company info validation error
  COMPANY_NAME: 'Enter company name',
  COMPANY_NATIONAL_NUMBER: "Enter company's national number",
  COMPANY_INVALID_NATIONAL: 'Invalid national number',
  COMPANY_ECONOMIC: 'Enter economic code',
  COMPANY_REGISTER: 'Enter registeration number',
  COMPANY_ADDRESS: "Enter company's address",

  ENTER_NATIONAL_ID_NUMBER: 'Enter passport ID',
  INVALID_NATIONAL_ID_NUMBER: 'Invalid passport ID',

  ENTER_PHONE: 'Enter phone number',
  INVALID_PHONE: 'Invalid phone number',
  ENTER_PROVINCE: 'Enter province',
  ENTER_CITY: 'Enter city',
  ENTER_POSTAL_CODE: 'Enter zip code',
  INVALID_POSTAL_CODE: 'Invalid zip code',
  ENTER_RESIDENCE_ADDRESS: 'Enter your residential address',

  ONE_TIME_CODE_IS_INCORRECT: 'The entered code is incorrect!',
  //RESPONSE DELAY
  RESPONSE_DELAY_FORM_TYPE_ERROR:
    'Please enter the values for all fields correctly!',
  RESPONSE_DELAY_FORM_ERROR: 'The added form value is empty!',
  RESPONSE_DELAY_FORM_SUBMIT: 'Delay operation has been successfully created.',
  RESPONSE_DELAY_CONDITION: 'Delay operation has been successfully modified.',
  RESPONSE_DELAY_CONDITION_DELETE:
    'Delay operation has been successfully deleted.',
  RESPONSE_DELAY_IN_CONVERSATION_COUNT_ERROR:
    'The number of operations in conversation has reached the maximum allowed limit (3)!',
  RESPONSE_DELAY_IN_COMING_COUNT_ERROR:
    'The number of operations waiting for a response has reached the maximum allowed limit (3)!',
  RESPONSE_DELAY_ALL_DEPARTMENTS_COUNT_ERROR:
    'The number of operations defined for all departments has reached the maximum allowed limit (3)!',
  RESPONSE_DELAY_DEPARTMENT_SELECTED_COUNT_ERROR:
    'The number of operations defined for the selected department has reached the maximum allowed limit (3)!',

  // FORM GENERATOR
  FORM_GENERATOR_SUBMIT: 'The request form has been created successfully.',
  ONLY_PERSIAN_CHARS_VALID: 'Only persian characters are valid',
  PERSIAN_ADDRESS_INVALID:
    'Only persian characters, numbers and seperators are valid',

  PACKAGE_EXPIRE_SOON_BANNER_TEXT:
    'Only #days# left until your package expires. Please renew it',
  REMAINING_CONVS_ENDING_BANNER_TEXT:
    'Only #convs# conversations remaining. Please charge it.',
  REMAINING_CONVS_ENDED_BANNER_TEXT:
    "Your account's Remaining conversation is ended. Please renew it.",

  // KNOWLEDGE BASE
  KNOWLEDGE_BASE_SEND_DATA: 'Data sent successfully.',
  KNOWLEDGE_BASE_GET_DATA: 'Data retrieved successfully.',
  KNOWLEDGE_BASE_LINK_COPIED:
    'Your knowledge base link has been copied successfully!',

  FORM_GENERATOR_FORM_ERROR: 'The added form value is empty!',
  FORM_GENERATOR_FORM_EMPTY_ERROR: 'No form has been created!',

  // RESPONSIVE ROBOT
  RESPONSIVE_ROBOT_OPERATION_DELETE:
    'The desired operation has been successfully deleted.',
  RESPONSIVE_ROBOT_OPERATION_UPDATE:
    'The desired operation has been successfully updated.',
  RESPONSIVE_ROBOT_SUBMIT:
    'The desired operation has been successfully created.',
  RESPONSIVE_ROBOT_FORM_ERROR: 'All fields must be filled out!',
  ENTER_BIRTH_DATE: 'Enter birth date',

  LARGE_FILE_UPLOADED: 'The uploaded logo is larger than the allowed size!',

  // USER vISITS ARCHIVE
  REQUEST_ADD_FILTER_SUCCESS: 'Selected filters applied successfully.',
  REQUEST_ADD_FILTER_FAILURE: 'An issue occurred while applying filters!',
  REQUEST_ADD_FILTER_CHANNEL_ID_FAILURE:
    'An issue occurred while applying filters. Please try again later!',
  REQUEST_EXPORT_USER_VISITS_SUCCESS:
    'As soon as the output file is ready, we will email it to you',
  REQUEST_EXPORT_USER_VISITS_FAILURE:
    'An issue occurred while requesting the export file!',

  DELETE_WEBSITE: 'The desired website has been successfully deleted',

  UPGRADE_TO_ADD_NEW_WEBSITE: 'Upgrade your package to add a new website',
};

export default MESSAGES;
